<template>
  <div class="viewing-discipline-tests" id="viewing-discipline-tests">
    <!-- <h4 class="page-title test-header" >Тесты</h4> -->
    <div class="carousel-wrp">
      <div class="control-block">
        <div class="control-block__test-counter">
          <button class="test-counter__btn" @click="changeSlide(-1)">
            <i class="el-icon-arrow-left"></i>
          </button>
          Тест:
          <span>{{ activeIndex + 1 }}</span>
          / Всего тестов: <span>{{ normalizeTests.length }}</span>
          <button class="test-counter__btn" @click="changeSlide(1)">
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>
        <el-select
          ref="selectTest"
          placeholder="Выберите тест"
          @change="changeTest"
          v-model="valueSelect"
        >
          <el-option
            v-for="(item, idx) in normalizeTests"
            :key="idx"
            :label="item.name"
            :value="idx"
          >
          </el-option>
        </el-select>
      </div>
      <el-carousel
        ref="carousel"
        trigger="click"
        indicator-position="outside"
        arrow="never"
        :height="heightCarousel + 'px'"
        :autoplay="false"
      >
        <el-carousel-item
          :name="String(key1)"
          v-for="(test, key1) of normalizeTests"
          :key="key1"
        >
          <el-collapse
            v-for="(question, key2) in test.questions"
            :key="key2"
            v-model="activeName"
            accordion
          >
            <el-collapse-item :name="key2">
              <template slot="title">
                <b class="question">Вопрос:</b>
                <span class="question__text" v-html="question.html"></span>
              </template>
              <ul>
                <li class="question__header"><b>Ответы:</b></li>
                <li
                  class="question__content"
                  v-for="(answer, key3) in question.answers"
                  :key="key3"
                >
                  <div>
                    <i
                      class="fas fa-check label question__content-label"
                      v-show="answer.right"
                    ></i>
                  </div>
                  <span>{{ key3 }}</span>
                  <span
                    class="question__content-response"
                    v-html="answer.html"
                  ></span>
                </li>
              </ul>
            </el-collapse-item>
          </el-collapse>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "viewingTests",
  data() {
    return {
      valueSelect: 0,
      activeName: 0,
      carousel: null,
    };
  },
  computed: {
    activeIndex() {
      if (!this.carousel) return 0;
      return this.carousel.activeIndex;
    },
    storeTests() {
      return this.$store.state.viewingDiscipline.treeData.tests;
    },
    normalizeTests() {
      if (!this.storeTests) return [];
      const array = [];
      for (let key in this.storeTests) {
        if (this.storeTests[key].length) {
          this.storeTests[key].forEach((element) => {
            array.push(element);
          });
        }
      }
      return array;
    },
    heightCarousel() {
      return this.mobileMode ? 376 : 340;
    },
    selectedTest() {
      return this.$store.state.viewingDiscipline.settingTest;
    },
    settingTestIndex() {
      if (!this.selectedTest) return null;
      return this.normalizeTests.findIndex((el) => el === this.selectedTest);
    },
  },
  methods: {
    // ...mapMutations(["setSettingTest"]),
    changeTest(v) {
      this.carousel.setActiveItem(v);
    },

    changeSlide(value) {
      value < 0 ? this.$refs.carousel.prev() : this.$refs.carousel.next();
      this.valueSelect = this.carousel.activeIndex;
    },
    setSlideDefault() {
      if (this.normalizeTests.length) {
        this.carousel.setActiveItem(this.settingTestIndex);
        this.valueSelect = this.settingTestIndex;
      }
    },
    // setHeightCarousel() {
    //   this.heightCarousel = this.$refs.testsWrp.scrollHeight - 160;
    // },
  },
  mounted() {
    this.carousel = this.$refs.carousel;
    if (this.selectedTest) this.setSlideDefault();
  },
  beforeDestroy() {
    //this.setSettingTest(0);
  },
};
</script>

<style lang="scss">
.viewing-discipline-tests {
  height: 100%;
  .test-header {
    margin: 0;
    height: 60px;
    display: flex;
    align-items: center;
  }
  .control-block {
    height: 90px;
  }
  .el-select {
    display: block;
  }
  .control-block__test-counter {
    text-align: center;
    color: $secondary-text-clr;
    margin-bottom: 10px;
    span {
      color: $brand-clr-1;
    }
  }
  .test-counter__btn {
    transition-duration: 0.3s;
    transition-property: background-color;
    border: 1px solid $secondary-text-clr;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    margin: 0 10px;
    &:hover {
      background-color: $brand-clr-1;
      color: $basic-white;
      border-color: $brand-clr-1;
    }
    &:active {
      background-color: lighten($color: $brand-clr-1, $amount: 10%);
    }
  }
  .el-carousel {
    .el-carousel__item {
      overflow-y: scroll;
    }
  }
  ul {
    padding-left: 20px;
  }
  li {
    list-style: none;
  }
  .el-collapse-item__header {
    height: auto;
    padding: 15px;
    &:hover {
      background-color: $light-border-clr;
    }
  }
  .question,
  .question__text {
    line-height: 20px;
    font-size: 18px;
    margin: 0;
    text-transform: lowercase;
  }
  .question::first-letter,
  .question__text::first-letter {
    text-transform: uppercase;
  }
  .question__text {
    padding-left: 10px;
  }
  .question__header {
    font-size: 18px;
  }
  .question__content {
    display: grid;
    grid-template-columns: 30px 30px auto;
    align-items: center;
    justify-items: center;
    font-size: 18px;
    padding: 5px 0;
  }
  .question__content-label {
    color: $success-clr;
  }
  .question__content-response {
    justify-self: start;
    line-height: 1;
  }
  .question__content-response::first-letter {
    text-transform: uppercase;
  }
  .el-carousel__indicators {
    .el-carousel__button {
      background-color: $brand-clr-1;
    }
  }
  .el-carousel__arrow:hover {
    background-color: $brand-clr-1;
  }
}
</style>